import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '@open-portal-app/core/services/auth.service';

import { environment } from '@open-portal-env';

import * as constant from '../../core/constants/overview.constants';

@Component({
  selector: 'overview-landing',
  templateUrl: './overview-landing.component.html',
  styleUrls: ['./overview-landing.component.scss']
})
export class OverviewLandingComponent implements OnInit {
  pageComponents: any;

  constructor(
    private route: ActivatedRoute,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      const { campaign } = params;
      if (!constant[campaign as keyof typeof constant]) {
        window.location.href = constant.FALLBACK_URL.url;
      }
      this.pageComponents = constant[campaign as keyof typeof constant].components;
      (window as any).opensdk.load(this.authService.getApiKey(), {
        apiEndpoint: environment.apiEndpoint,
        portalUrl: (window as any).location.origin,
        authToken: this.authService.getCustomerToken()
      });
    });
  }

  startQuote(product: any){
    (window as any).opensdk.quote.prepare(product)
      .then((response: any) => {
        if (product === 'hud-compare-home') {
          window.location.href = `${environment.huddleFrontal}/?key=${this.authService.getApiKey()}&pc=${product}&qr=${response.quote_ref}`;
        } else {
          window.location.href = `/?key=${this.authService.getApiKey()}&pc=${product}&qr=${response.quote_ref}`;
        }
      });
  }
}
